<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">

      <div class="row m-3 justify-content-center">

        <div class="col-lg-10">
          <div class="row">
            <div class="col-8">
              <p class="h4">
                <b>Escolha a cidade</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>

          <div class="mb-4">
            <div class="form-icon position-relative">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                   class="feather feather-search fea icon-sm icons">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg>
              <input name="city" id="city" class="form-control ps-5" placeholder="Pesquisar cidade" v-model="search">
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate" @click="selectCity(city)"
               style="cursor: pointer;" v-for="city in cities" :title="'Agendar em ' + city.city_name">
              <div class="text-center m-3">
                <i class="fas fa-2x fa-map-marker-alt text-primary"></i> <br>
                <b class="h5 text-primary">{{city.city_name}} - {{city.state_initials}}</b>
              </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExamCities',
  data() {
    return {
      search: '',
    }
  },
  computed: {
    cities() {
      let cities = this.$store.state.toSchedule.cities;
      if (this.search === '')
        return cities;

      return cities.filter(city => {
        let strFilter = JSON.stringify(city);
        return strFilter.toLowerCase().includes(this.search.toLowerCase())
      });
    },
  },
  mounted() {
    this.$store.dispatch('toSchedule/getExamCities');
  },
  methods: {
    selectCity(city) {
      this.$store.commit('toSchedule/selectCity', city);
      this.$router.push('/exams/types');
    },
  }
}
</script>

<style scoped>

</style>
